import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private storageKey = 'fi-theme';
  private readonly themeRevision = signal(0);
  readonly revision = this.themeRevision.asReadonly();
  isDark = false;

  constructor() {
    const stored = localStorage.getItem(this.storageKey) || 'light';
    this.isDark = stored === 'dark';
    this.apply();
  }

  toggle() {
    this.isDark = !this.isDark;
    localStorage.setItem(this.storageKey, this.isDark ? 'dark' : 'light');
    this.apply();
  }

  set(theme: 'light' | 'dark') {
    this.isDark = theme === 'dark';
    localStorage.setItem(this.storageKey, theme);
    this.apply();
  }

  getTheme(): 'light' | 'dark' {
    return this.isDark ? 'dark' : 'light';
  }

  private apply() {
    const cls = 'dark';
    if (this.isDark) {
      document.documentElement.classList.add(cls);
    } else {
      document.documentElement.classList.remove(cls);
    }

    this.themeRevision.update((value) => value + 1);
  }
}
